import { artworks } from "@/mocks/gallery";

export default function Hot() {
  const hot = artworks.filter((a) => a.featured).slice(0, 4);

  return (
    <section id="hot" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">Trending Now</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">本周热门推荐</h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              编辑部与广大同好共同甄选的本周人气作品，每一幅都值得细细收藏与品味。
            </p>
          </div>
          <a
            href="#gallery"
            className="inline-flex items-center whitespace-nowrap rounded-full border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition hover:border-primary-400 hover:text-primary-600 cursor-pointer"
          >
            更多推荐
            <i className="ri-arrow-right-line ml-1.5"></i>
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {hot.map((a, i) => (
            <a
              key={a.id}
              href="#gallery"
              className="group relative overflow-hidden rounded-xl"
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden">
                <img
                  src={a.image}
                  alt={`热门作品${a.title} ${a.style}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <span className="absolute left-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-xs font-bold text-foreground-950">
                  {i + 1}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="font-heading text-base font-semibold text-white md:text-lg">{a.title}</h3>
                  <p className="mt-1 text-xs text-white/75">@{a.artist} · {a.style}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}